<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-row>
      <el-form-item class="select_btn_160" v-if="activeTab == '1' || activeTab == '4'">
        <el-select
          class="select_btn_style"
          v-model="filters.displayClientTypes"
          placeholder="展示终端"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, i) in displayTypeList"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          clearable
          prefix-icon="el-icon-search"
          size="small"
          v-model="filters.keyWord"
          placeholder="资源名称"
        ></el-input>
      </el-form-item>
      <el-form-item class="m-l-14">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
export default {
  props: {
    activeTab: {
      type: String,
      default: ""
    },
    displayTypeList: {
      type: Array,
      default: () => []
    }
  },
  components: { butn },
  data() {
    return {
      filters: {},
    }
  },
  created() {
  },
  methods: {
    initData() {
      // if (this.filters.displayClientTypes.includes("")) {
      //   delete this.filters.displayClientTypes;
      // }
      let params = { ...this.filters };
      params.page = 1;
      this.$emit("search", params);
    },
    resetData() {
      this.filters = {};
      this.$emit("search", {});
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.serach-form {
  text-align: left;
  border-bottom: 1px dashed #ebeef5;
  margin-bottom: 20px;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
  .name-input {
    width: 250px;
    margin-right: 10px;
  }
}
</style>
